import { View } from '@/styles/reactnative';
import { ThemeContext } from '@/theme/ThemeProvider';
import { useIsMobile } from '@utils/CalVW.tsx';
import BigNumber from 'bignumber.js';
import { useCallback, useContext } from 'react';
import { useIndexPrice } from '../../../../../../hooks/trade/indexprice';
import { useTradeSetting } from '../../../../../../hooks/trade/tradeSetting';
import useTradeStore from '../../../../../../hooks/trade/tradeStore';
import QuantityCostFormList from './QuantityCostFormList';
import { t } from 'i18next';
import styled from 'styled-components';

const QuantityCostForm = () => {
  const { data: store } = useTradeStore();
  const { data: setting } = useTradeSetting(store?.ep_id);
  // const [MS, setMS] = React.useState("M");

  const {
    isDarkMode,
  } = useContext(ThemeContext);

  // console.log("tradeStore", store);

  const { getPrice } = useIndexPrice(store?.ep_id);

  const leverage = setting?.leverage || 20;
  let price = store?.order_price || 0;
  const amount = store?.order_amount || 0;

  if (store?.limit_market != 'L') {
    price = getPrice(store?.ep_id);
  }

  const orderType = store?.main_sub || 'M';
  const isQty = orderType === 'M';

  const calculateValue = useCallback(
    (price, amount, leverage) => {
      const value = new BigNumber(price)
        .multipliedBy(new BigNumber(amount))
        .div(leverage);

      if (isQty) {
        return value;
      } else {
        return value.div(price);
      }
    },
    [isQty]
  );

  const value = calculateValue(price, amount, leverage);

  // const value = new BigNumber(price)
  //   .multipliedBy(amount)
  //   .dividedBy(leverage)
  //   .toNumber();

  let bidsvalue = Number(
    (price * amount).toFixed(store?.dp2 || 3)
  )?.toLocaleString('ko-kr');
  let asksvalue = Number(
    (price * amount).toFixed(store?.dp2 || 3)
  )?.toLocaleString('ko-kr');

  if (!isQty) {
    const v = new BigNumber(amount).div(price);

    bidsvalue = v.toFormat(5);
    asksvalue = v.toFormat(5);
  }

  return (
    <Wrapper>
      <CustomView>
        <QuantityCostFormList
          title={isQty ? t('Value') : t('qty')}
          bids={bidsvalue}
          asks={asksvalue}
          type={isQty ? store?.pairs?.split('/')[1] : t('QTY')}
        />
        <QuantityCostFormList
          title={t('cost')}
          bids={value.toFormat(3)}
          asks={value.toFormat(3)}
          type={store?.pairs?.split('/')[1]}
        />
      </CustomView>
    </Wrapper>
  );
};

export default QuantityCostForm;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 4px 12px 0 12px;
`;

const CustomView = styled(View)`
  width: 100%;
  align-items: flex-start;
  justify-content: flex-start;
  border: 1px solid #353535;
  border-radius: 6px;
  gap: 8px;
  padding: 10px;
`;
